import _ from 'lodash'
import { Component } from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

class Sync extends Component {
    constructor(props) {
        super(props)

        // Disable sync
        if (!this.props.settings.enabled) return

        // Interval multipliers
        this.second = 1000
        this.minute = this.second * 60

        // Timers
        this.timer_default_interval = this.props.settings.timer.interval_seconds * this.second
        this.timer_default_delay = this.props.settings.timer.delay_minutes * this.minute
        this.timer_multiplier = this.props.settings.timer.multiplier

        // Counter for how long the
        // launcher window has been idle
        this.idleTime = 0

        // Interval time for sync
        this.syncTime = this.timer_default_interval

        // Interval variables
        this.idleInterval = undefined

        // Initialize
        this.incrementIdleTimer()

        // Watch window events to reset idle timer
        window.onmousemove = () => this.resetIdleTimer()
        window.onkeypress = () => this.resetIdleTimer()
    }

    shouldComponentUpdate(nextProps) {
        return this.props.hash !== nextProps.hash
    }

    componentDidUpdate(prevProps) {
        if (prevProps.hash !== this.props.hash) {
            if (this.props.hash === undefined) {
                // Get the newest hash from syncHash.json
                this.getHash()
            } else {
                // Read contents of the sync file
                this.readFromSync()
            }
        }
    }

    // Update sync data
    setSyncData = (data) => {
        try {
            // Update news hash
            if (data.news != null) this.props.updateNews(data.news)

            // Update ad timestamp
            if (data.creatives != null) this.props.updateCreatives(data.creatives)

            // Update motd timestamp
            if (data.motd != null) this.props.updateMotd(data.motd)

            // Update twitch status
            if (data.twitch != null) this.props.updateTwitch(data.twitch)

            // Update background
            if (this.props.settings.fallback.overwriteBackground !== 'undefined') {
                this.props.updateBackground(
                    `/content/images/${this.props.settings.fallback.overwriteBackground}`,
                )
            } else if (data.background != null) {
                this.props.updateBackground(data.background.background)
            } else {
                this.props.updateBackground(this.props.settings.fallback.background)
            }

            // Update versions
            if (data.version != null) {
                // Set up the regular expression rule
                const regex = new RegExp(this.props.versionRegex, 'i')

                // Get the matches for versions
                const versions = _.mapValues(data.version, (value) => {
                    const version = value.match(regex)
                    if (version[1]) return version[1]
                    return value
                })

                this.props.updateVersions(versions)
            }

            // Process data for Tranquility
            if (data.tq != null) {
                this.props.updateServerStatus('tq', data.tq.serverStatus, data.tq.userCount)
            }

            // Process data for Singularity
            if (data.sisi != null) {
                this.props.updateServerStatus('sisi', data.sisi.serverStatus, data.sisi.userCount)
            }
        } catch (error) {
            console.info(
                `Encountered an error while running setSyncData: ${
                    error.message
                } -data- ${JSON.stringify(data)}`,
            )
        }
    }

    // Get the short hash from S3
    getHash = () => {
        // Fetch contents from the hash file
        axios
            .get(this.props.settings.url.hash)
            .then(({ data: { h: hash } }) => {
                // If the hash is set and has changed
                // trigger fetching a new sync file
                if (hash != null && hash !== this.props.hash) {
                    // Update the stored hash
                    this.props.updateHash(hash)
                }
            })
            .catch(error =>
                console.info(
                    `Encountered error while fetching hash file content: ${error.message}`,
                ),
            )
    }

    readFromSync = () => {
        try {
            axios
                .get(this.props.settings.url.sync)
                .then(({ data }) => {
                    this.setSyncData(data)
                })
                .catch(ex =>
                    console.info(
                        `Encountered error while fetching sync file content: ${ex.message}`,
                    ),
                )
        } catch (error) {
            console.info(`Encountered an error while running readFromSync: ${error.message}`)
        }
    }

    // Increment the idle timer
    incrementIdleTimer = () => {
        // IdleTime in this context is number of times
        // this function has been called without mouse
        // or keyboard activity on the launcher
        if (this.idleTime >= 6) {
            // After 2x timer_default_delay start applying a multiplier
            this.syncTime = this.timer_default_delay * this.timer_multiplier
        } else if (this.idleTime >= 4) {
            // After a full minute update the sync time
            // to the delay setting
            this.syncTime = this.timer_default_delay
        } else if (this.idleTime > 0) {
            // Reset or make sure the sync time is the default interval
            this.syncTime = this.timer_default_interval
        }

        // Increment the idle time by one
        this.idleTime += 1

        // Clear the current interval
        clearTimeout(this.idleInterval)

        // Set new interval as appropriate
        this.idleInterval = setTimeout(this.incrementIdleTimer, this.syncTime)

        // Get hash
        this.getHash()
    }

    resetIdleTimer = () => {
        // If the sync time is higher than the default interval
        // as a result of a delay we
        if (this.syncTime > this.timer_default_interval) {
            // Reset the sync time value
            this.syncTime = this.timer_default_interval

            // Reset the idle timer
            this.idleTime = 0

            // Call the increment function
            this.incrementIdleTimer()
        }
    }

    render() {
        return null
    }
}

Sync.propTypes = {
    hash: PropTypes.string,
    updateServerStatus: PropTypes.func,
    updateNews: PropTypes.func,
    updateCreatives: PropTypes.func,
    updateMotd: PropTypes.func,
    updateTwitch: PropTypes.func,
    updateVersions: PropTypes.func,
    updateHash: PropTypes.func,
    updateBackground: PropTypes.func,
    versionRegex: PropTypes.string,
    settings: PropTypes.shape({
        enabled: PropTypes.bool,
        timer: PropTypes.shape({
            interval_seconds: PropTypes.number,
            delay_minutes: PropTypes.nubmer,
            multiplier: PropTypes.number,
        }),
        fallback: PropTypes.shape({
            overwriteBackground: PropTypes.string,
            background: PropTypes.string,
        }),
        url: PropTypes.shape({
            hash: PropTypes.string,
            sync: PropTypes.string,
        }),
    }),
}

export default Sync



// WEBPACK FOOTER //
// ./src/features/Sync/components/Sync/component.js